import { render, staticRenderFns } from "./ManagementKits.vue?vue&type=template&id=674360d9&"
import script from "./ManagementKits.vue?vue&type=script&lang=js&"
export * from "./ManagementKits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports